<template>
  <div class="testing_request_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div class="col-12">
          <input
            class="form-control"
            placeholder="Search supplier code..."
            v-on:keyup.enter="onSearchSupplierCode"
          />
        </div>
      </div>

      <div class="col-6 offset-3">
        <div class="col-12 mt-3">
          <b-table :items="rawShipmentProducts.data" :fields="rawShipmentProducts.fields"
                   v-if="rawShipmentProducts.data">
              <template slot="cell(ingredient_id)" slot-scope="row">
                  {{ row.item.ingredient_name }}
                  <div v-if="row.item.ingredient_coa">
                      <b-iconstack font-scale="1.5" variant="success">
                          <b-icon stacked icon="check"></b-icon>
                      </b-iconstack>
                  </div>
              </template>

            <template slot="cell(supplier_code)" slot-scope="row"> {{ row.item.supplier_code }}</template>
            <template slot="cell(supplier_batch_number)" slot-scope="row"> {{
                row.item.supplier_batch_number
              }}
            </template>
            <template slot="cell(unique_batch_number)" slot-scope="row">
              {{ row.item.raw_shipment_id + "-" + row.item.supplier_code }}
            </template>
            <template slot="cell(manufacturing_date)" slot-scope="row"> {{ row.item.manufacturing_date }}</template>
            <template slot="cell(actions)" slot-scope="row">
              <div>
                <b-button
                  size="sm"
                  variant="warning"
                  class="ml-2"
                  @click="addSample(row.item)"
                >Add
                </b-button
                >
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-6 offset-3">
        <h5 class="text-center">Samples</h5>

      </div>

      <div class="col-6 offset-3">
        <div class="col-12 mt-3">
          <b-table :items="samples.data" :fields="samples.fields"
                   v-if="samples.data">

              <template slot="cell(testing_request_sample_id)" slot-scope="row">
                  {{ row.item.testing_request_sample_id }}
                  <div v-if="row.item.ingredient_coa">
                      <b-iconstack font-scale="1.5" variant="success">
                          <b-icon stacked icon="check"></b-icon>
                      </b-iconstack>
                  </div>
              </template>
            <template slot="cell(ingredient_id)" slot-scope="row"> {{ row.item.ingredient_name }}</template>
            <template slot="cell(supplier_code)" slot-scope="row"> {{ row.item.supplier_code }}</template>
            <template slot="cell(supplier_batch_number)" slot-scope="row"> {{
                row.item.supplier_batch_number
              }}
            </template>
            <template slot="cell(unique_batch_number)" slot-scope="row">
              {{ row.item.raw_shipment_id + "_" + row.item.supplier_code }}
            </template>
            <template slot="cell(manufacturing_date)" slot-scope="row"> {{ row.item.manufacturing_date }}</template>
            <template slot="cell(actions)" slot-scope="row">
              <div>
                <b-button
                  size="sm"
                  variant="danger"
                  class="ml-2"
                  @click="deleteItem(row.item.testing_request_sample_id)"
                >Delete
                </b-button
                >
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "testing-request-sample",
  data() {
    return {
      sample: [
        {
          testing_request_id: "",
          raw_shipment_product_id: "",
        }
      ],
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Testing Requests", to: { name: "testing-requests" } },
        { text: "Add Sample", active: true }
      ],
      rawShipmentProducts: {
        fields: [
          { key: "ingredient_id", label: "Ingredient" },
          { key: "supplier_code", label: "Supplier Code" },
          { key: "supplier_batch_number", label: "Supplier Batch Number" },
          { key: "manufacturing_date", label: "Manufacturing Date" },
          { key: "unique_batch_number", label: "Unique Batch Number" },
          { key: "actions", label: "", width: 100 }
        ],
        data: []
      },
      samples: {
        data: [],
        fields: [
          { key: "testing_request_sample_id", label: "#" },
          { key: "ingredient_id", label: "Ingredient" },
          { key: "supplier_code", label: "Supplier Code" },
          { key: "supplier_batch_number", label: "Supplier Batch Number" },
          { key: "manufacturing_date", label: "Manufacturing Date" },
          { key: "unique_batch_number", label: "Unique Batch Number" },
          { key: "actions", label: "", width: 100 }
        ]
      }
    };
  },
  validations: {
    sample: {
      required,
      $each: {
        testing_request_id: {
          required
        },
        raw_shipment_product_id: {
          required
        },
      }
    }
  },
  mounted: function () {
    this.getSamples();
  },
  methods: {
    onSearchSupplierCode(event) {
      this.rawShipmentProducts.data = [];

      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL +
        this.BRAND +
        "/raw/shipments/search/product/" +
        event.target.value
      )
      .then(
        response => {
          this.rawShipmentProducts.data = response.data.raw_shipment_products;
          loader.hide();
        },
        error => {
          loader.hide();
        }
      );
    },
    getSamples() {
      let loader = this.$loading.show();
      this.$http
      .get(
        this.APIURL +
        this.BRAND +
        "/testing/requests/" +
        this.$route.params.id +
        "/samples"
      )
      .then(
        response => {
          if ( response.data.length > 0 ) {
            this.samples.data = response.data;
          }
          loader.hide();
        },
        error => {
          console.log(error);
        }
      );
    },
    deleteItem(id) {
      this.submit = true;
      //show loader
      let loader = this.$loading.show();

      this.$http
      .post(
        this.APIURL +
        this.BRAND +
        "/testing/requests/" +
        id +
        "/samples/delete",
      )
      .then(
        response => {
          if ( response.data.status == "failed" ) {
            this.$swal({
              title: "Failed!",
              showConfirmButton: true,
              html: this.convertToHtmlList(response.data.errors),
              type: "error",
              onClose: () => {
                loader.hide();
              }
            });
          } else {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Sample deleted successfully",
              type: "success",
              onClose: () => {
                loader.hide();
                setTimeout(() => window.location.reload(), 1000)
              }
            });
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    convertToHtmlList(errors) {
      let htmlMessage = "";
      errors.forEach(function (error) {
        htmlMessage += error + "<br/>";
      });
      return htmlMessage;
    },
    addSample(item) {
      this.submit = true;
      //show loader
      let loader = this.$loading.show();

      this.$http
      .post(
        this.APIURL +
        this.BRAND +
        "/testing/requests/" +
        this.$route.params.id +
        "/samples",
        {
          sample: {
            testing_request_id: this.$route.params.id,
            raw_shipment_product_id: item.raw_shipment_product_id
          }
        }
      )
      .then(
        response => {
          if ( response.data.status == "failed" ) {
            this.$swal({
              title: "Failed!",
              showConfirmButton: true,
              html: this.convertToHtmlList(response.data.errors),
              type: "error",
              onClose: () => {
                loader.hide();
              }
            });
          } else {
            this.$swal({
              title: "Success!",
              showConfirmButton: false,
              timer: 1000,
              html:
                "Sample added successfully",
              type: "success",
              onClose: () => {
                loader.hide();
                setTimeout(() => window.location.reload(), 1000)
              }
            });
          }
        },
        error => {
          console.log(error);
        }
      );
    }
  }
};
</script>
